<template>
  <v-layout row class="align-center layout pl-4 pr-2 py-1 app--page-header">
    <div v-if="$vuetify.breakpoint.smAndUp" class="page-header-left">
      <h3 class="pr-3 font-weight-regular">{{ title }}</h3>
    </div>
    <v-breadcrumbs v-if="$vuetify.breakpoint.mdAndUp" divider="-">
      <v-breadcrumbs-item>
        <v-icon>home</v-icon>
      </v-breadcrumbs-item>
      <v-breadcrumbs-item
        v-for="(item, key) in breadcrumbs"
        :key="`breadcrumbs-${key}`"
      >
        {{ item }}
      </v-breadcrumbs-item>
    </v-breadcrumbs>
    <v-spacer></v-spacer>
    <!-- <v-menu v-if="$route.meta.filter.periode"
            v-model="menuPeriode"
            :close-on-content-click="false"
            transition="scale-transition"
            lazy
            :z-index="1"
            offset-y>
      <v-text-field slot="activator"
                    prepend-inner-icon="assignment_turned_in"
                    type="text"
                    placeholder="Periode"
                    solo
                    hide-details
                    flat
                    readonly
                    style="width:120px"
                    v-model="periode"></v-text-field>
      <v-date-picker v-model="periode"
                     no-title
                     type="year"
                     :mix="2017"
                     :max="$moment().format('YYYY')"
                     locale="id-id">
        <v-layout>
          <v-flex xs6>
            <v-btn color="red"
                   flat
                   block
                   @click="periode = ''">RESET</v-btn>
          </v-flex>
          <v-flex xs6>
            <v-btn color="primary"
                   dark
                   block
                   @click="menuPeriode = false">OK</v-btn>
          </v-flex>
        </v-layout>
      </v-date-picker>
    </v-menu> -->
    <template v-if="$route.meta.filter">
      <div
        v-if="$route.meta.filter.periode && !$route.query.id"
        style="width: 140px"
      >
        <v-select
          prepend-inner-icon="assignment_turned_in"
          hide-details
          solo
          attach
          dense
          :z-index="1"
          flat
          clearable
          :items="periodeItem"
          v-model="periode"
          label="Thn"
        >
        </v-select>
      </div>
      <div
        v-if="$route.meta.filter.laman && !$route.query.id"
        style="width: 70px"
      >
        <v-select
          item-text="laman"
          item-value="id_laman"
          :items="laman"
          hide-details
          flat
          attach
          :z-index="1"
          solo
          v-model="id_laman"
        >
        </v-select>
      </div>
    </template>
    <div class="page-header-right">
      <v-btn icon @click="toggleReload">
        <v-icon class="text--secondary">refresh</v-icon>
      </v-btn>
    </div>
  </v-layout>
</template>

<script>
import MainMenus from "@/constants/mainMenus";
import { mapState, mapGetters } from "vuex";

export default {
  name: "page-header",
  props: {
    detail: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      title: "",
      // menuPeriode: false,
      periodeItem: []
    };
  },
  computed: {
    ...mapGetters(["laman$"]),
    ...mapState(["id_laman$", "periode$"]),
    ...mapState("laman", ["laman"]),
    periode: {
      get() {
        return this.periode$;
      },
      set(val) {
        if (!val) val = "";
        this.$store.commit("SET_PERIODE", val);
      }
    },
    id_laman: {
      get() {
        return this.id_laman$;
      },
      set(val) {
        this.$store.dispatch("SET_LAMAN", val);
      }
    },
    breadcrumbs: function() {
      let breadcrumbs = [];
      for (let i = 0; i < MainMenus.length; i++) {
        if (MainMenus[i].items) {
          let child = MainMenus[i].items.find(j => {
            return j.name === this.$route.name;
          });
          if (child) {
            breadcrumbs.push(MainMenus[i].title);
            breadcrumbs.push(child.title);
            this.setTitle(child.title, this.laman$);
            if (this.$route.query.id) breadcrumbs.push(this.$route.query.id);
          }
        } else {
          if (MainMenus[i].name === this.$route.name) {
            this.setTitle(MainMenus[i].title, this.laman$);
            breadcrumbs.push(MainMenus[i].title);
            if (this.$route.query.id) breadcrumbs.push(this.$route.query.id);
          }
        }
      }
      return breadcrumbs;
    }
  },
  methods: {
    setTitle(title, laman$) {
      if (
        !(
          this.$route.meta.noLamanInBreadcrumbs ||
          this.$route.meta.noBreadcrumbs
        )
      )
        title = title + ` (${laman$}) `;
      this.title = title;
    },
    toggleReload() {
      this.$store.commit("TOGGLE_RELOAD");
      this.$nextTick(function() {
        this.$store.commit("TOGGLE_RELOAD");
      });
    }
  },
  created() {
    let min = 2017;
    let max = parseInt(this.$moment().format("YYYY"));
    for (let year = max; year >= min; year--) {
      this.periodeItem.push(year.toString());
    }
    this.periode = max.toString();
  },
  mounted() {
    this.$store.dispatch("laman/GET_LAMAN");
  }
};
</script>
